var map = {
	"./A0.png": 1857,
	"./B0.png": 1858,
	"./BB.png": 1859,
	"./BD.png": 1860,
	"./C0.png": 1861,
	"./D0.png": 1862,
	"./E0.png": 1863,
	"./ecosentino-small.png": 1864,
	"./ecosentino.png": 1865,
	"./icon-dekton.png": 1866,
	"./icon-scalea.png": 1867,
	"./icon-sensa.png": 1868,
	"./icon-silestone.png": 1869,
	"./icon-table.png": 1870,
	"./products/mktools.png": 1871,
	"./sinks.png": 1872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 807;